import { useMemo } from 'react';

import { getCurrencies } from 'helpers/currencies';
import type { Currency } from 'types/entities/currency';

export function useGetAllCurrencies(): Currency[] {
  return useMemo(() => getCurrencies(), []);
}
